<template>
    <div class="content ht-100v pd-0">
        <div class="content-body pd-10">
            <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                <div>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                            <li class="breadcrumb-item">
                                <router-link to="/account/">Payments</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Beneficiary Management</li>
                        </ol>
                    </nav>
                    <h4 class="mg-b-0 tx-spacing--1">Beneficiary Management</h4>
                </div>
                <div class="d-none d-md-block">

                    <button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
                        <router-link class="tx-white" to="/account/account-activities">
                            <file-icon class="wd-10 mg-r-5"></file-icon>
                            View Activities
                        </router-link>
                    </button>
                    <b-button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5">
                        <router-link class="tx-white" to="/account/account-statement">
                            <printer-icon class="wd-10 mg-r-5"></printer-icon>
                            Statements
                        </router-link>
                    </b-button>

                </div>
            </div>
            <view-account-card></view-account-card>
            <hr>
            <BeneficiaryTable />
        </div>
    </div>
</template>

<script>
    import ViewAccountCard from "../../components/card/ViewAccountCard";
    import {FileIcon, PrinterIcon} from 'vue-feather-icons'
    import {mapState, mapGetters } from 'vuex'
    import BeneficiaryTable from "@/components/table/BeneficiaryTable";

    export default {
        name: 'AccountView',
        data() {
            return {
                'cards': [],
                'accload': false,
                'accountsss': ['2083474695 - Zenith Bank', '2083474699 - Rubies'],
                'busy': false,
            }
        },
        components: {
          BeneficiaryTable,
            ViewAccountCard,
            FileIcon,
            PrinterIcon,
        },
        computed: {
            accounts: function () {
                return this.$store.state.account.allAccounts;
            },
            authobj: function () {
                return this.$store.state.auth.response
            },
            ...mapState(['account']),
            ...mapGetters({
              beneficiaryOption: 'account/beneficiaryOptions',
            })
        },
        methods: {
            readAccounts: async function () {
                let payload = {customerid: this.authobj.customerid};
                await this.$store.dispatch("account/getAllAccount", payload, {root: false});
            }
        },
        mounted() {
            this.readAccounts();
            //this.accounts = this.items.map(acc => acc.accountno);
        }
    }


</script>

<style scoped>

</style>
